import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import RitoService from '../../app/service/RitoService'

class Ritos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rito: null,
      ritos: [],
      codigo: '',
      nome: '',
      modalRito: false,
      modalRitoAlterar: false,
      openSpinner: false,
    }

    this.ritoService = new RitoService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroRitos = this.renderFooterCadastroRitos.bind(this);
    this.renderFooterAlterarRitos = this.renderFooterAlterarRitos.bind(this);
  }

  listarRitos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.ritoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({ritos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Ritos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({rito: null});
    this.setState({nome: ''});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarRito(rowData)}
                tooltip="Editar Rito" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Rito" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(rito) {
    this.setState({codigo: rito.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Rito de Processo?',
        header: 'Exclusão de Rito de Processo',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirRito() {
    this.setState({openSpinner: true});
    this.ritoService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Ritos do Processo', detail:'Rito do Processo excluído com sucesso', life: 4000});
        this.listarRitos();
      });
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirRito();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroRitos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarRito}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarRitos(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarRito}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarRito(rito){
    this.setState({openSpinner: true});
    this.ritoService.consultar(rito.codigo)
      .then(response => {
        this.setState({rito: response.data});
        this.setState({nome: response.data.nome});
        this.setState({codigo: response.data.codigo});
        this.abrirModaAlterar('modalRitoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Ritos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarRito = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Ritos do Processo', detail:'O nome do Rito do Processo é obrigatório', life: 4000});
      return;
    }
    const rito = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.ritoService.cadastrar(rito)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Ritos do Processo', detail:'Rito do Processo cadastrado com sucesso', life: 4000});
        this.fecharModal('modalRito');
        this.listarRitos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Ritos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarRito = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Ritos do Processo', detail:'O nome do Rito do Processo é obrigatório', life: 4000});
      return;
    }

    const rito = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.ritoService.alterar(rito)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Ritos do Processo', detail:'Rito do Processo alterado com sucesso', life: 4000});
        this.fecharModal('modalRitoAlterar');
        this.listarRitos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Ritos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarRitos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Ritos do Processo */}
          <Dialog header="Cadastro de Ritos de Processo"
                    visible={this.state.modalRito} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroRitos('modalRito')} 
                    onHide={() => this.fecharModal('modalRito')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeRito">Nome</label>
                        <InputText id="nomeRito" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Ritos de Processo */}
          <Dialog header="Alterar Ritos de Processo"
                    visible={this.state.modalRitoAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarRitos('modalRitoAlterar')} 
                    onHide={() => this.fecharModal('modalRitoAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeRitoAlterar">Nome</label>
                        <InputText id="nomeRitoAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-check-square"></i>
                        <span> Ritos de Processo</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalRito')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="pi pi-check-square"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.ritos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum rito encontrado" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

Ritos.contextType = AuthContext;
export default withRouter (Ritos)